<div class="sidebar-menu-wrapper">
    <div class="flex justify-content-center align-items-center my-4">
        <a class="layout-topbar-logo cursor-pointer" (click)="navigateHome()">
            <span><img src="assets/images/smarthink-main-white-logo.svg" alt="logo" /></span>
        </a>
    </div>

    <ul class="layout-menu">
        <p-panelMenu class="mt-1" [model]="items" />
    </ul>

    <div class="flex flex-column justify-content-center mt-6">
        <h3>{{ 'sidebar.preferencesTitle' | translate }}</h3>
        <div class="flex align-content-center gap-2">
            <i class="material-icons mi-contrast"></i>
            <label>{{ 'sidebar.darkMode' | translate }}</label>
            <p-inputSwitch class="ml-4" [(ngModel)]="isDarkMode" (onChange)="toggleDarkMode($event.checked)" />
        </div>
    </div>
</div>
